import React, { useState, useEffect } from 'react';

import { formatNumber } from 'components/base/common/utils';
import { dateService } from 'services/date';
import { api } from 'services/api';

import growthIcon from 'images/icons/trending-up.png';

const totalsOptions = [
	{
		label: 'Total Article Results',
		name: 'articles',
		text: 'new stories published in the last 30 days',
	},
	{
		label: 'Total Product Recommendations',
		name: 'products',
		text: 'new products added in the last 30 days',
	},
	{
		label: 'Total Revenue',
		name: 'revenue',
		text: 'in revenue added in the last 30 days',
	},
];

function ArticleSearchTotals({ orgId, filter, chips }) {
	// State
	const [loading, setLoading] = useState(true);
	const [showTotals, setShowTotals] = useState(true);
	const [totals, setTotals] = useState({});

	// Effects
	useEffect(() => {
		fetchTotals();
	}, [orgId, chips]);

	// Methods
	async function fetchTotals() {
		setLoading(true);

		const totalsEndpoint = `/api/v0/merchants/${orgId}/article_search/totals/`;
		const params = getQueryParams();
		const resp = await api.get(totalsEndpoint, params);
		const totals = resp.data.data[0].stats;

		setTotals(totals);
		setLoading(false);
	}

	function getQueryParams() {
		const thirtyDay = dateService.getPresetDateRanges().thirtyDay;
		const encodedChips = chips.map((chip) => encodeURIComponent(chip));
		return {
			date_from: dateService.formatDate(thirtyDay.startDate),
			date_to: dateService.formatDate(thirtyDay.endDate),
			search_query: encodedChips.join(','),
			type: filter,
		};
	}

	function formatTotal(count, name) {
		const total = parseFloat(count);
		const decimalPlace = total % 1 !== 0 ? 2 : 0;
		const abbreviations = ['', 'K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
		const decimalIndex = total
			? Math.floor(Math.log(total) / Math.log(1000))
			: total;
		const result = `${
			(total / 1000 ** decimalIndex).toFixed(decimalPlace)
		}${abbreviations[decimalIndex]}`;

		return name === 'revenue' ? `$${result}` : result;
	}

	// Render
	const totalsDetail = showTotals ? (
		<div className="totals-detail">
			{totalsOptions.map((item, i) => {
				const last = totals[item.name];
				const total = totals[`total_${item.name}`];
				const value = item.name === 'revenue'
					? formatTotal(total, item.name)
					: formatNumber(total);
				return (
					<div key={i} className="totals-block">
						<p className="label">{item.label}</p>
						<p className="value">{value}</p>
						<div className="growth">
							<img src={growthIcon} alt="trending up" />
							<p className="growth-value">
								<span>{formatTotal(last, item.name)}</span> {item.text}
							</p>
						</div>
					</div>
				);
			})}
		</div>
	) : null;

	const searchDescriptor = chips.length > 1 ? `+ ${chips.length - 1} more terms` : '';

	const totalsDash = !loading ? (
		<div className="totals">
			<div className="totals-header">
				<div className="title">
					Displaying results for <span className="search">"{chips[0]}"</span> {searchDescriptor}
				</div>
				<div className="totals-btn"
					onClick={() => setShowTotals(!showTotals)}>
					<span>{`${showTotals ? 'Hide' : 'Show'} Dashboard`}</span>
					<span className={`icon ${showTotals ? 'up' : 'down'}`} />
				</div>
			</div>
			{totalsDetail}
		</div>
	) : null;

	return totalsDash;
}

export default ArticleSearchTotals;
